import { useState } from "react";
import Grid from "@mui/system/Unstable_Grid/Grid";

import Button from "@Components/Button";
import { formatDate } from "@Utils/functions";
import { LenderTicket } from "@Types/tickets";
import { useCreateNote } from "@Hooks/useNotes";
import useCurrentUser from "@Hooks/useCurrentUser";
import TextField from "@Components/Inputs/TextField";

import styles from "./LenderNotes.module.scss";

type LenderNotesProps = {
  ticket: LenderTicket;
};
const LenderNotes = ({ ticket }: LenderNotesProps) => {
  const notes = ticket.data.lenderNotes ?? [];

  const currentUser = useCurrentUser();
  const [newNote, setNewNote] = useState("");
  const { createNote, loading } = useCreateNote();

  const handleCreateNote = () => {
    if (newNote && !loading) {
      createNote({
        data: {
          ticketId: ticket._id,
          info: {
            creator: "lender",
            note: newNote,
            user: {
              firstName: currentUser?.data?.info?.firstName || null,
              lastName: currentUser?.data?.info?.lastName || null,
              email: currentUser?.data?.info?.email || null,
            },
          },
        },
      });
      setNewNote("");
    }
  };
  return (
    <div className={styles.container}>
      <Grid xs={12}>
        <div className={styles.title}>Notes</div>
      </Grid>
      <Grid container xs={12} className={styles.notesContainer}>
        <Grid xs={12} className={styles.notes}>
          {notes
            .filter((note) => note?.data?.info?.note)
            .map((note, index) => (
              <Grid
                key={index}
                container
                xs={12}
                justifyContent="space-between"
                alignItems="center"
                rowSpacing={1}
                className={styles.itemContainer}
              >
                <Grid
                  xs={12}
                  className={
                    note.data.info.creator === "lender"
                      ? styles.itemLender
                      : styles.item
                  }
                >
                  <span className={styles.noteDescription}>
                    {note?.data?.info?.note}
                  </span>
                  <div
                    className={
                      note.data.info.creator === "lender"
                        ? styles.noteCreatorLender
                        : styles.noteCreator
                    }
                  >
                    {[
                      note.data?.info?.user?.firstName,
                      note?.data?.info?.user?.lastName,
                      formatDate(note?.createdAt, "medium", true),
                    ]
                      .filter((x) => x)
                      .join(" ")}
                  </div>
                </Grid>
              </Grid>
            ))}
        </Grid>
      </Grid>
      <Grid
        xs={12}
        container
        className={styles.createNoteContainer}
        spacing={2}
      >
        <Grid xs={9}>
          <TextField
            onChange={(e) => setNewNote(e.target.value)}
            placeholder="Add note"
            value={newNote}
            name="note"
            type="text"
            required
            id="create-note"
          />
        </Grid>
        <Grid xs={3}>
          <Button type="button" variant="blue" onClick={handleCreateNote}>
            Send
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
export default LenderNotes;
